import React from 'react'
import { MasonryItem } from './MasonryItem'
import { MASONRY_CONFIG } from '../constants'

export function MasonryGrid({ items, onItemClick }) {
  const { AREA_CYCLE, CHUNK_SIZE } = MASONRY_CONFIG
  const chunks = []
  
  for (let i = 0; i < items.length; i += CHUNK_SIZE) {
    chunks.push(items.slice(i, i + CHUNK_SIZE))
  }
  
  return (
    <>
      {chunks.map((chunk, chunkIndex) => (
        <div key={`chunk-${chunkIndex}`} className="masonry-block">
          {chunk.map((item, itemIndex) => {
            const areaName = AREA_CYCLE[itemIndex % AREA_CYCLE.length]
            return (
              <MasonryItem
                key={item.filename}
                item={item}
                areaName={areaName}
                onClick={onItemClick}
              />
            )
          })}
        </div>
      ))}
    </>
  )
}

